module.exports = __webpack_public_path__ + "static/img/logo.88fd37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/logo.png
// module id = RT0D
// module chunks = 171